import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notificarion',
  templateUrl: './notificarion.component.html',
  styleUrls: ['./notificarion.component.scss']
})
export class NotificarionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
